// @flow
import type { Location } from 'types/entities';

import React, { Component } from 'react';
import _ from 'lodash';
import classnames from 'classnames';

type Props = {
  className?: string,
  value: Location,
  onBeforeChange?: Function,
  onChange: Function,
};

type State = {
  rawValue: string,
}

const VALID_COORDINATE = /^-?\d+(\.[\d]+)?$/;

function formatLocation(value: Location): string {
  if (value[1] != null && value[0] != null) {
    return `${value[1]}, ${value[0]}`;
  }

  return '';
}

function parseCoordinate(value: string): number {
  if (value.trim().match(VALID_COORDINATE)) {
    return parseFloat(value);
  }

  return NaN;
}

function parseValue(value: string): Location {
  const coordinates = value.split(/\s*,\s*/);
  if (coordinates.length < 2) {
    return [NaN, NaN];
  }
  const parsedCoordinates = coordinates.map(parseCoordinate);
  return [parsedCoordinates[1], parsedCoordinates[0]];
}

function isValidValue(value: Location): boolean {
  return !Number.isNaN(value[0]) && !Number.isNaN(value[1]);
}

export default class InputLocation extends Component {
  static defaultProps = {
    className: '',
    onBeforeChange: null,
  }

  constructor(props: Props) {
    super(props);
    this.state = { rawValue: formatLocation(this.props.value) };
  }

  state: State;

  componentWillReceiveProps(nextProps: Props) {
    if (!_.isEqual(this.props.value, nextProps.value)) {
      this.setValue(nextProps.value);
    }
  }

  getValue() {
    return parseValue(this.state.rawValue);
  }

  setValue(value: Location) {
    this.setRawValue(formatLocation(value));
  }

  setRawValue(value: string, callback?: Function) {
    this.setState({ rawValue: value }, callback);
  }

  isValid(): boolean {
    return isValidValue(this.getValue());
  }

  props: Props;

  handleChange(event: Event & { target: HTMLInputElement }) {
    this.setRawValue(event.target.value, () => {
      if (this.props.onBeforeChange) {
        this.props.onBeforeChange();
      }

      const values = parseValue(this.state.rawValue);
      if (!isValidValue(values)) {
        return;
      }

      if (this.props.onChange) {
        this.props.onChange(values);
      }
    });
  }

  render() {
    const otherProps = _.omit(this.props, 'value', 'onBeforeChange', 'onChange', 'className');
    return (
      <input
        className={classnames('input', this.props.className)}
        {...otherProps}
        type="text"
        value={this.state.rawValue}
        onFocus={(event) => {
          event.target.select();
        }}
        onChange={event => this.handleChange(event)}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/form/InputLocation.jsx
 **/